import { Box, Typography } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const LabelContainer = styled(Box)`
  background-color: ${theme.colors.labelCardBg};
  border: 1px solid ${theme.colors.borderMedium};
  border-radius: ${theme.attributes.borderRadius.tertiary};
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.md}px;
  height: 124px;

  &:hover {
    background-color: ${theme.colors.labelCardHover};
    border-color: ${theme.colors.borderMedium};
  }

  html[data-theme='light'] & {
    background-color: #fafafb;
    border-color: ${theme.colors.strokePrimary};

    &:hover {
      background-color: ${theme.colors.cardFillTertiary};
    }
  }
`

export const LabelHeader = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const LabelContent = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.half}px;
`

export const LabelFooter = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const TitleWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xSmall}px;
  flex: 1;
`

export const IconWrapper = styled(Box)<{ labelType: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg path {
    stroke: ${theme.colors.cardDateText};
  }
`

export const Title = styled(Typography)<{ titleColor: string }>`
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.large};
  font-style: normal;
  font-weight: ${theme.typography.fontWeight.extraThick};
  line-height: 20px;
  color: ${({ titleColor }) => titleColor};
`

export const Description = styled(Typography)`
  color: ${theme.colors.textSecondary};
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.medium};
  font-style: normal;
  font-weight: ${theme.typography.fontWeight.bold};
  line-height: 16px;
  padding-right: 36px;
  white-space: pre-line;
`

export const MetaInfo = styled(Typography)`
  color: ${theme.colors.cardDateText};
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.medium};
  font-style: normal;
  font-weight: ${theme.typography.fontWeight.bold};
  line-height: 16px;

  & span {
    color: ${theme.colors.textSecondary};
    font-size: ${theme.typography.fontSize.medium};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.bold};
    line-height: 16px;
  }
`

export const DateInfo = styled(Typography)`
  color: ${theme.colors.cardDateText};
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.medium};
  font-style: normal;
  font-weight: ${theme.typography.fontWeight.bold};
  line-height: 16px;
`

export const ActionButtons = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.half}px;
  height: 20px;
`

export const PrivacyIcon = styled(Box)`
  svg path {
    stroke: ${theme.colors.cardDateText};
  }
`
